<script setup lang="ts">
</script>

<template>
	<Block>
		<AppHeader :layout="'dashboard'" />
		<main class="relative pt-[6.797rem] min-h-[90vh] max-md:pt-[5.1rem]">
			<Block class="mx-auto max-w-[116rem] px-[2rem]">
				<Breadcrumb />
			</Block>
			<slot />
		</main>
		<AppFooter :layout="'dashboard'" />
	</Block>
</template>
